class PromiseSet {
	private readonly _set = new Set<Promise<any>>();
	private set_empty: Promise<void> = Promise.resolve();
	private on_done: () => void = () => void 0;
	add(promise: Promise<any>): typeof promise {
		if (this._set.size === 0) {
			this.set_empty = new Promise((resolve) => {
				this.on_done = resolve;
			});
		}
		this._set.add(promise);
		promise.finally(() => {
			this._set.delete(promise);
			if (this._set.size === 0) {
				this.on_done();
				this.set_empty = Promise.resolve();
			}
		});
		return promise;
	}
	empty(): Promise<void> {
		return this.set_empty;
	}
	get size() {
		return this._set.size;
	}
}

const query_queue = new PromiseSet();

export function add(promise: Promise<any>): typeof promise {
	return query_queue.add(promise);
}

export function done(): Promise<void> {
	return query_queue.empty();
}

export function size(): number {
	return query_queue.size;
}
